import React from 'react';
import { Search } from 'lucide-react';
import { Button } from '../ui/button';
import { useGlobalSearch } from './hooks';
import { cn } from '../../lib/utils';

interface GlobalSearchTriggerProps {
  variant?: 'default' | 'outline' | 'ghost' | 'icon';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  className?: string;
  showKeyboardShortcut?: boolean;
  placeholder?: string;
}

export const GlobalSearchTrigger: React.FC<GlobalSearchTriggerProps> = ({
  variant = 'outline',
  size = 'default',
  className,
  showKeyboardShortcut = true,
  placeholder = 'Search...'
}) => {
  const { openSearch } = useGlobalSearch();

  if (variant === 'icon' || size === 'icon') {
    return (
      <Button
        variant={variant === 'icon' ? 'ghost' : variant}
        size="icon"
        className={cn('h-8 w-8', className)}
        onClick={openSearch}
        title="Search (⌘K)"
      >
        <Search className="h-4 w-4" />
      </Button>
    );
  }

  return (
    <Button
      variant={variant}
      size={size}
      className={cn('justify-start text-muted-foreground', className)}
      onClick={openSearch}
    >
      <Search className="mr-2 h-4 w-4" />
      <span>{placeholder}</span>
      {showKeyboardShortcut && (
        <kbd className="pointer-events-none ml-auto inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100">
          <span className="text-xs">⌘</span>K
        </kbd>
      )}
    </Button>
  );
};